import { useState, FC, useEffect, } from 'react';
// 组件
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { ProButton, ProCheckbox, ProForm, ProInput, ProSpace, } from '../../../antd';
// 方法
import { useNavigate } from 'react-router-dom';
import { user_authUserInfo_api } from '../../../api/user';
import { passwordEncryption } from '../../../utils/loginUtils';
import { responseError } from '../../../utils/messageUtils';
// 常量
import { IS_MOBILE, SUCCESS_STATUS_CODE } from '../../../constants/constant';
import { LOGIN_INFO_KEY } from '../../../constants/localStorage';
import { LoginInfo } from '../../interface';
import { toAtob, toBtoa } from '../../../utils/password';

interface PasswordLoginProps {
  /** 公钥 */
  publicKey?: string;
  /** 登录成功回调 */
  onSuccess: (data: LoginInfo) => void;
}
const PasswordLogin: FC<PasswordLoginProps> = (props) => {
  const { publicKey, onSuccess } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const routerNavigate = useNavigate();
  const [form] = ProForm.useForm();
  useEffect(() => {
    const loginInfoStr = window.localStorage.getItem(LOGIN_INFO_KEY);
    if (loginInfoStr) {
      try {
        const loginInfo = JSON.parse(loginInfoStr);
        const historyData = {
          ...loginInfo,
          password: toAtob(loginInfo.password),
        };
        form.setFieldsValue(historyData);
      } catch {}
    }
  }, []);
  /** 去注册 */
  const handleRegister = () => {
    routerNavigate('/authView/register');
  };
  /** 登录 */
  const handleFinish = async (values: any) => {
    if (!publicKey) {
      responseError('初始化信息加载失败');
      return;
    }
    const { userName, password, remember, } = values;
    const ciphertext = passwordEncryption(password, publicKey);
    setLoading(true);
    // 登录
    const res = await user_authUserInfo_api(userName, ciphertext);
    setLoading(false);
    if (res.code === SUCCESS_STATUS_CODE) {
      const data = res.data;
      const {accessToken, refreshToken, accessTokenTimeToLive} = data;
      if (remember) {
        window.localStorage.setItem(LOGIN_INFO_KEY, JSON.stringify({
          userName,
          remember,
          password: toBtoa(password),
        }));
      } else {
        window.localStorage.removeItem(LOGIN_INFO_KEY);
      }
      onSuccess({
        accessToken,
        refreshToken,
        expires: accessTokenTimeToLive,
      });
    }
  };
  return (
    <ProForm className='login-form' size='large' form={form} onFinish={handleFinish}>
      <ProForm.Item
        name='userName'
        rules={[{ required: true, message: '请输入用户名' }]}
      >
        <ProInput
          prefix={<UserOutlined />}
          placeholder="请输入用户名"
        />
      </ProForm.Item>
      <ProForm.Item
        name="password"
        rules={[{ required: true, message: '请输入密码' }]}
      >
        <ProInput.Password
          prefix={<LockOutlined />}
          type="password"
          placeholder="请输入密码"
        />
      </ProForm.Item>
      <ProForm.Item>
        <ProSpace style={{ justifyContent: 'space-between', width: '100%', }}>
          <ProForm.Item noStyle name="remember" valuePropName="checked">
            <ProCheckbox>记住密码</ProCheckbox>
          </ProForm.Item>
          {/* <div style={{ fontSize: 12, }}>
            <span>没有账号？</span>
            <span
              className='link-text'
              onClick={handleRegister}
            >去注册</span>
          </div> */}
        </ProSpace>
      </ProForm.Item>
      
      <ProForm.Item className='login-form-sub'>
        <ProButton type="primary" htmlType="submit" block loading={loading}>
          登录
        </ProButton>
      </ProForm.Item>
    </ProForm>
  );
};

export default PasswordLogin;
